export const SESSION_SETUP_EDITING = "session_setup/editing";
export const SESSION_SETUP_CONFIRM = "session_setup/setup-confirm";
export const SESSION_SETUP_MOVE_STEP = "session_setup/setup-move-step";
export const SESSION_SETUP_TOGGLE_SHOW = "session_setup/setup-toggle-show";
export const SESSION_SETUP_SET_VALUE = "session_setup/setup-set-value";
export const SESSION_SETUP_SET_QUESTION = "session_setup/setup-set-question";
export const SESSION_SETUP_SET_PRODUCT_NUMBER = "session_setup/setup-set-product-number";
export const SESSION_SETUP_ERROR = "session_setup/setup-set-error";
export const SESSION_SETUP_RESET = "session_setup/reset";
